export enum ImageMenuItem {
  RemoveHeader,
  RemoveCaption,
  ToggleHeader,
  ToggleCaption,
  ToggleCrop,
  CloseHeadingMenu,
  CloseCaptionMenu,
  ShowLinkInput,
  CloseLinkInput,
  ReplaceImage,
  DeleteImage,
}

export enum TextMenuItem {
  ToggleBold,
  ToggleItalic,
  ToggleUnderline,
  ToggleStrike,
  ToggleOrderedList,
  ToggleBulletList,
  Undo,
  Redo,
  ShowLinkInput,
  ShowMergeTagMenu,
  CloseLinkInput,
  DeleteText,
}

export enum FormMenuItem {
  Undo,
  Redo,
  Bold,
  Italic,
  Underline,
  CloseLinkInput,
  ShowLinkInput,
}

export enum PricingTableMenuItem {
  ToggleBold,
  ToggleItalic,
  ToggleUnderline,
  ToggleStrike,
  ToggleOrderedList,
  ToggleBulletList,
  Undo,
  Redo,
  ShowLinkInput,
  ShowMergeTagMenu,
  CloseLinkInput,
}

export enum TableMenuItem {
  ToggleBorder,
  ToggleHeaderRow,
  ToggleAlternateRowColor,
  DeleteColumn,
  DeleteRow,
  ToggleBold,
  ToggleItalic,
  ToggleUnderline,
  ToggleStrike,
  ToggleOrderedList,
  ToggleBulletList,
  Undo,
  Redo,
  ShowLinkInput,
  CloseLinkInput,
  ShowMergeTagMenu,
  DeleteTable,
}

export enum VideoMenuItem {
  ReplaceVideo,
  DeleteVideo,
}
